<template>
  <div>

    <v-row>

      <v-col cols="12" md="6">

        <v-text-field v-model="filter" prepend-icon="mdi-currency-usd" label="Filter transactions"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <RangePicker @reloadData="loadData" :range="this.getDefaultWeek()" />
      </v-col>
    </v-row>


    <v-data-table :search="filter" :items-per-page="-1" @current-items="getFiltered" :headers="headers"
      :items="transactions" item-key="id">
      <template v-slot:item.amend="{ item }">

        <v-container class="controls" v-if="checkGate('void-transaction')">
          <div v-if="item.status === 'paid'" class="v-text-field">

            <v-btn class="red--text" @click="voidItem(item)" v-if="item.category != 'split' && item.category != 'pckg'"
              icon>
              <v-icon v-if="item.method == 'CC'">mdi-credit-card-refund</v-icon>
              <v-icon v-else>mdi-cash-refund</v-icon>
            </v-btn>

            <v-btn class="red--text" @click="refund(item)" v-if="item.category == 'pckg'" icon>
              <v-icon v-if="item.method == 'CC'">mdi-credit-card-refund</v-icon>
              <v-icon v-else>mdi-cash-refund</v-icon>
            </v-btn>
          </div>


          <div v-else-if="item.status != 'paid'" class="v-text-field">

            <v-btn class="green--text" @click="undoVoidItem(item)"
              v-if="item.category != 'split' && item.category != 'pckg'" icon>
              <v-icon v-if="item.method == 'CC'">mdi-credit-card-plus</v-icon>
              <v-icon v-else>mdi-cash-plus</v-icon>
            </v-btn>

            <v-btn class="green--text" @click="undoRefund(item)" v-if="item.category == 'pckg'" icon>
              <v-icon v-if="item.method == 'CC'">mdi-credit-card-plus</v-icon>
              <v-icon v-else>mdi-cash-plus</v-icon>
            </v-btn>
          </div>

          <v-select :items="paymentMethods(item)" v-model="item.method" width="30px" :loading="savingPaymentMethod"
            @change="changePaymentMethod(item)" />
        </v-container>
      </template>

      <template v-slot:item.price="{ item }">

        <span v-if="item.status == 'refunded'">${{ -Math.abs(item.price) }} </span>
        <span v-else>${{ item.price }} </span>
      </template>
      <template v-slot:item.created_at="{ item }">
        <span>{{ new Date(item.created_at).toLocaleString("en-AU", {
          timeZone: "UTC", weekday: 'short', year: 'numeric',
          month: 'short', day: 'numeric'
        }) }}</span>
      </template>

      <template v-slot:item.notes="{ item }">
        <ul>
          <li v-if="item.notes">{{ item.notes }}</li>
          <li v-if="item.loadNotes"><small>load Notes: </small>{{ item.loadNotes }}</li>
        </ul>
      </template>
      <template slot="body.append">
        <tr class="pink--text">
          <th class="title">Total</th>
          <th class="title">${{ total }}</th>
        </tr>
      </template>

    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RangePicker from '../components/RangePicker.vue'
//import AmendTransaction from '../components/AmendTransaction.vue'



export default {

  components: { RangePicker },

  data() {


    return {

      dialog: false,
      savingPaymentMethod: false,
      filter: '',
      total: 0,
      filtered: []

    }
  },

  mounted() {

    this.$store.dispatch('fetchTransactions', {
      range: this.getDefaultWeek()
    })

  },


  computed: {

    ...mapState(['transactions']),

    headers() {

      let headers = this.getHeaders(this.transactions)
      let id = headers.shift()
      let customer_id = headers.shift()

      return headers
    },


  },


  methods: {

    paymentMethods(item) {

      let m = ['CC', 'Cash']

      if (item.category == 'pckg') {
        m.push('prepaid')
      }

      return m

    },

    getFiltered(e) {

      //this.calculateTotal(e)
      this.total = this.sum(e, 'price')
      this.filtered = e
    },


    loadData(range) {

      this.$store.dispatch('fetchTransactions', {
        range: range

      })

    },

    refund(item) {

      item.status = 'refunded'

      axios.put('/api/customers/refundJump/' + item.customer_id, { item: item })
        .then(response => {

          this.calculateTotal(item)
          //item.price = -item.price

        }).catch(err => {

          // this.errorMessage = err
          // if (err) {
          //   this.errorText = err.response.request.response
          //   this.errorURL = err.response.request.responseURL
          // }
        })
    },

    undoRefund(item) {
      item.status = 'paid'


      axios.put('/api/customers/undoRefundJump/' + item.customer_id, { item: item })
        .then(response => {

          this.calculateTotal(item)
          //item.price = item.price * 1
        }).catch(err => {

          // this.errorMessage = err

          // if (err) {
          //   this.errorText = err.response.request.response
          //   this.errorURL = err.response.request.responseURL
          // }
        })

    },

    voidItem(item) {

      item.status = 'refunded'


      axios.put('/api/sales/voidTransaction/' + item.customer_id, { item: item })
        .then(response => {

          this.calculateTotal(item)
          //item.price = -item.price

        })
        .catch(err => {
          // this.errorMessage = err
          // if (err) {
          //   this.errorText = err.response.request.response
          //   this.errorURL = err.response.request.responseURL
          // }
        })

    },

    undoVoidItem(item) {

      item.status = 'paid'

      axios.put('/api/sales/undoVoidTransaction/' + item.customer_id, { item: item })
        .then(response => {

          this.calculateTotal(item)
          //item.price = item.price * 1
        })
        .catch(err => {
          // this.errorMessage = err
          // if (err) {
          //   this.errorText = err.response.request.response
          //   this.errorURL = err.response.request.responseURL
          // }
        })
    },

    changePaymentMethod(item) {



      this.savingPaymentMethod = true

      axios.put('/api/customers/changePaymentMethod/' + item.customer_id, { item: item })
        .then(response => {

          this.savingPaymentMethod = false
          //this.calculateTotal(item)
        }).catch(err => {

          // this.errorMessage = err
          // if (err) {
          //   this.errorText = err.response.request.response
          //   this.errorURL = err.response.request.responseURL
          // }
        })

    },

    refund(item) {

      item.status = 'refunded'

      axios.put('/api/customers/refundJump/' + item.customer_id, { item: item })
        .then(response => {

          this.calculateTotal(item)
          //item.price = -item.price

        }).catch(err => {

          // this.errorMessage = err
          // if (err) {
          //   this.errorText = err.response.request.response
          //   this.errorURL = err.response.request.responseURL
          // }
        })
    },

    undoRefund(item) {
      item.status = 'paid'


      axios.put('/api/customers/undoRefundJump/' + item.customer_id, { item: item })
        .then(response => {

          this.calculateTotal(item)

        }).catch(err => {

          // this.errorMessage = err

          // if (err) {
          //   this.errorText = err.response.request.response
          //   this.errorURL = err.response.request.responseURL
          // }
        })

    },

    voidItem(item) {

      item.status = 'refunded'


      axios.put('/api/sales/voidTransaction/' + item.customer_id, { item: item })
        .then(response => {

          this.calculateTotal(item)


        })
        .catch(err => {
          // this.errorMessage = err
          // if (err) {
          //   this.errorText = err.response.request.response
          //   this.errorURL = err.response.request.responseURL
          // }
        })

    },

    undoVoidItem(item) {

      item.status = 'paid'

      axios.put('/api/sales/undoVoidTransaction/' + item.customer_id, { item: item })
        .then(response => {

          this.calculateTotal(item)
          //item.price = item.price * 1
        })
        .catch(err => {
          // this.errorMessage = err
          // if (err) {
          //   this.errorText = err.response.request.response
          //   this.errorURL = err.response.request.responseURL
          // }
        })
    },

    changePaymentMethod(item) {

      this.savingPaymentMethod = true

      axios.put('/api/customers/changePaymentMethod/' + item.customer_id, { item: item })
        .then(response => {
          this.savingPaymentMethod = false
        }).catch(err => {

          // this.errorMessage = err
          // if (err) {
          //   this.errorText = err.response.request.response
          //   this.errorURL = err.response.request.responseURL
          // }
        })

    },


    calculateTotal(item) {

      const index = this.transactions.indexOf(item)
      Object.assign(this.transactions[index], item)
      //because refunded items' price is negative
      this.total = item.status == 'refunded' ? this.total + item.price : this.total - item.price


    },
  }
}
</script>